/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { banquetCartModifierRequestSchema } from "./banquetCartModifierRequestSchema.ts";

export const banquetCartGroupModifierRequestSchema = z.object({
	group: z.uuid(),
	modifiers: z.array(banquetCartModifierRequestSchema),
});
